export default {
  // Table column titles
  columns: {
    mainRouteCode: 'Main Route Code',
    airlineName: 'Airline Name',
    belongingAlliance: 'Belonging Alliance',
    portOfAffairs: 'Port of Call',
    coCabinParty: 'Co-cabin Party',
    enabled: 'Status'
  },

  // Button texts
  buttons: {
    addRoute: 'Add Route',
    refresh: 'Refresh',
    detail: 'Detail',
    edit: 'Edit',
    more: 'More',
    enable: 'Enable',
    disable: 'Disable',
    back: 'Back',
    save: 'Save Basic Info',
    saveChanges: 'Save',
    cancel: 'Cancel',
    addPort: 'Add Port',
    addAgent: 'Add Agent',
    delete: 'Delete',
    update: 'Update',
    addSchedule: 'Add Schedule',
    addSpaceSharing: 'Add Space Sharing',
    addTransitPort: 'Add Transit Port',
    supplementFields: 'Supplement Fields',
    addNow: 'Add Now'
  },

  // Message prompts
  messages: {
    routeMaintenanceData: 'Route Maintenance Data',
    dataLoadFailed: 'Data loading failed',
    deleteSuccess: 'Delete successful',
    deleteFailed: 'Delete failed',
    enableSuccess: 'Enable successful',
    enableFailed: 'Enable failed',
    disableSuccess: 'Disable successful',
    disableFailed: 'Disable failed',
    saveSuccess: 'Save successful',
    saveFailed: 'Save failed',
    loadDataFailed: 'Load data failed',
    longTermScheduleUpdateSuccess: 'Long-term schedule updated successfully',
    longTermScheduleUpdateFailed: 'Long-term schedule update failed',
    basicInfoSaveSuccess: 'Basic information saved successfully',
    basicInfoSaveFailed: 'Basic information save failed'
  },

  // Confirm dialogs
  confirmDialog: {
    deleteTitle: 'Delete',
    deleteContent: 'Are you sure you want to delete this route?',
    operationTitle: 'Confirm Operation',
    enableContent: 'Are you sure you want to enable route {name}?',
    disableContent: 'Are you sure you want to disable route {name}?',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },

  // Status texts
  status: {
    enabled: 'Enabled',
    disabled: 'Disabled',
    unknown: 'Unknown',
    draft: 'Draft',
    published: 'Published'
  },

  // Other texts
  other: {
    allPorts: 'All Ports of Call',
    count: 'items',
    allParties: 'All co cabin parties: ',
    currentStatus: 'Current Status:',
    description: 'Description:',
    port: 'Port:',
    loading: 'Loading...'
  },

  // Alliance names
  alliance: {
    twoM: '2M Alliance',
    ocean: 'Ocean Alliance',
    the: 'THE Alliance',
    independent: 'Independent Operation'
  },

  // Tab pages
  tabs: {
    basicInfo: 'Basic Information',
    longTermScheduleInfo: 'Long-term Schedule'
  },

  // Long-term schedule related
  longTermSchedule: {
    title: 'Long-term Schedule',
    tableHeaders: {
      shipName: 'Ship Name',
      operator: 'Operator',
      internalVoyage: 'Internal Voyage',
      customsVoyage: 'Customs Voyage'
    },
    placeholders: {
      selectShip: 'Please select ship name',
      selectOperator: 'Please select operator',
      enterInternalVoyage: 'Please enter internal voyage',
      enterCustomsVoyage: 'Please enter customs voyage',
      selectETA: 'Select ETA',
      selectETD: 'Select ETD',
      selectCustomsClearanceTime: 'Please select customs clearance time',
      selectAntiTerrorTime: 'Please select anti-terror declaration time',
      selectVGMTime: 'Please select VGM time',
      selectDocumentTime: 'Please select document time',
      selectOOGListTime: 'Please select OOG List time',
      selectDangerousTime: 'Please select dangerous goods declaration time',
      selectSpaceSharing: 'Please select space sharing',
      enterInternalVoyageModal: 'Please enter internal voyage',
      enterCustomsVoyageModal: 'Please enter customs voyage'
    },
    emptyStates: {
      noScheduleInfo: 'No schedule information, please click "Add Schedule" button to add',
      noSpaceSharingInfo: 'No space sharing voyage information',
      noTransitPortInfo: 'No transit port information'
    },
    modal: {
      title: 'Supplement Fields Settings',
      spaceSharingTitle: 'Space Sharing Voyage',
      spaceSharingNumber: 'Space Sharing #{number}'
    },
    transitPort: {
      title: 'Transit Port',
      ordinal: 'Transit Port {number}',
      port: 'Port',
      routeCode: 'Route Code',
      vesselName: 'Vessel Name',
      voyage: 'Voyage',
      portPlaceholder: 'Please select transit port',
      routeCodePlaceholder: 'Please enter route code',
      vesselNamePlaceholder: 'Please enter vessel name',
      voyagePlaceholder: 'Please enter voyage',
      duplicateWarning: 'This port has been selected, transit ports cannot be duplicated',
      duplicateError: 'Transit ports cannot be duplicated, please modify and save again'
    },
    cutoffLabels: {
      customsClearance: 'Customs Clearance',
      antiTerrorDeclaration: 'Anti-Terror Declaration',
      vgm: 'VGM',
      document: 'Document',
      oogList: 'OOG List',
      dangerousGoods: 'Dangerous Goods Declaration'
    },
    descriptions: {
      main: 'Ship names come from basic data, operators come from co-cabin parties of the current route, and ports come from port information in basic information. Cells will be highlighted after filling in ETA/ETD. When adding the second and subsequent schedules, ETA/ETD will automatically add 7 days based on the corresponding port date of the previous row.',
      spaceSharing: 'Default times are automatically calculated based on ETA and corresponding port settings in basic information. You can adjust according to actual conditions. Space sharing parties come from space sharing settings in basic information.',
      transitPort: 'Transit port information is used to record transit port, route code, vessel name and voyage information. After deleting a transit port, subsequent numbering will be automatically adjusted.'
    }
  },

  // Detail page related
  detail: {
    // Page titles
    pageTitle: {
      create: 'Create Route',
      edit: 'Edit Route',
      view: 'Route Details'
    },

    // Section titles
    sections: {
      basicInfo: 'Basic Information',
      portInfo: 'Port of Call Information',
      agentInfo: 'Shipping Agent Information',
      statusInfo: 'Status Information'
    },

    // Form labels
    labels: {
      mainRouteCode: 'Main Route Code',
      airlineName: 'Airline Name',
      belongingAlliance: 'Belonging Alliance',
      coCabinParty: 'Co-cabin Party',
      carrier: 'Carrier',
      internalRouteCode: 'Internal Route Code',
      port: 'Port',
      dock: 'Dock',
      customsClearanceDay: 'Customs Clearance Day',
      antiTerrorDeclarationDay: 'Anti-Terror Declaration Day',
      documentDay: 'Document Day',
      departureDateDay: 'Departure Date Day',
      vgmDay: 'VGM Day',
      oogListDay: 'OOG List Day',
      dangerousGoodsDeclarationDay: 'Dangerous Goods Declaration Day',
      cabinShippingAgency: 'Cabin Shipping Agency',
      dangerousGoodsShippingAgent: 'Dangerous Goods Shipping Agent',
      status: 'Status',
      createTime: 'Create Time',
      updateTime: 'Update Time'
    },

    // Placeholder texts
    placeholders: {
      mainRouteCode: 'Enter route code, e.g.: AE7',
      airlineName: 'Enter airline name, e.g.: Asia Europe 7',
      belongingAlliance: 'Select belonging alliance',
      coCabinParty: 'Select co-cabin party (max 10)',
      selectCarrier: 'Please select carrier',
      internalRouteCode: 'Please enter internal route code (e.g., AE001)',
      selectWeekday: 'Select weekday',
      selectTime: '12:00',
      selectCoCabinParty: 'Select co-cabin party',
      selectCabinAgent: 'Select cabin shipping agent',
      selectDangerousAgent: 'Select dangerous goods shipping agent'
    },

    // Validation messages
    validation: {
      mainRouteCodeRequired: 'Please enter main route code',
      mainRouteCodeMaxLength: 'Route code max 10 characters',
      mainRouteCodeFormat: 'Route code can only contain uppercase letters and numbers',
      airlineNameRequired: 'Please enter airline name',
      belongingAllianceRequired: 'Please select belonging alliance',
      coCabinPartyRequired: 'Please select co-cabin party',
      carrierRequired: 'Please select carrier',
      internalRouteCodeRequired: 'Please enter internal route code',
      internalRouteCodeFormat: 'Internal route code should be 2-20 uppercase letters and numbers',
      maxSpaceSharingLimit: 'Maximum space sharing limit reached (20 groups)',
      duplicateSpaceSharing: 'This carrier already exists, please select another carrier',
      portRequired: 'Please select port'
    },

    // Help text
    helpText: {
      mainRouteCodeFormat: 'Route code can only contain uppercase letters and numbers'
    },

    // Empty state text
    emptyState: {
      noPortInfo: 'No port information',
      noAgentInfo: 'No agent information',
      noSpaceSharing: 'No space sharing information',
      clickToAddSpaceSharing: 'Click here or "Add Space Sharing" button to add partners'
    },

    // Dynamic text
    dynamic: {
      portNumber: 'Port {number}',
      agentNumber: 'Agent {number}',
      spaceSharingNumber: 'Space Sharing {number}'
    },

    // Export labels
    export: {
      portPrefix: 'Port '
    }
  }
}
